import React from 'react';
import { connect } from 'react-redux';
import LoginView from './LoginView';
import { login } from '../../actions/authActions';
import { PageTitle } from 'src/components/App';

export const LoginContainer = (props) => {
  return (
    <>
      <PageTitle title="Login" />
      <LoginView {...props} />
    </>
  );
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  login: (data) => {
    return new Promise((resolve, reject) => {
      dispatch(login(data, resolve, reject));
    });
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
